import React from 'react'
import styled from '@emotion/styled'
import { Button, Input } from 'antd'
import { PlusCircleOutlined } from '@ant-design/icons'

const StyledKeyListTop = styled.div({
  display: 'flex',
  alignItems: 'center',
  padding: '0.625rem 1.25rem'
})

const CreateButton = styled(Button)({
  marginLeft: 'auto'
})

const ApiKeyListTop = ({onNewKey}) => {
  return (
    <div>
      <StyledKeyListTop>
        <CreateButton type="primary" onClick={onNewKey}>
          <PlusCircleOutlined /> NEW API KEY
        </CreateButton>
      </StyledKeyListTop>
    </div>
  )
}

export default ApiKeyListTop
